<template>
    <div>
        <accordion-setting
            id="settingsDefault"
            title="Configurações"
            :visible="visible"
        >
            <!-- CONFIGURAÇÃO DE LARGURA -->
            <div class="py-2">
                <setting-frame-width
                    :item="item"
                    @onChangeWidth="onChangeWidth"
                />
            </div>
        </accordion-setting>
    </div>
</template>

<script>
import SettingFrameWidth from "../atoms/SettingFrameWidth.vue";
import AccordionSetting from '../atoms/AccordionSetting.vue';

export default {
    name: "SettingsFrameDefault",
    components: {
        SettingFrameWidth,
        AccordionSetting,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
        }
    },  
    methods: {
        handleSaveFrameConfig() {
            this.$emit("saveItemChanges", this.item);
        },
        onChangeWidth(item) {
            this.item.grid = item.grid;
            this.item.gridMobile = item.gridMobile;
                            
            this.handleSaveFrameConfig();
        },
    },
    created() {
        if (!this.item.extra) {
            this.item.extra = {};
        }
    },
};
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/molecules/SettingsFrameDefault.vue